import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

export default {
    async commentList(idx: number): Promise<types.ResCommentList> {
        const res = {} as types.ResCommentList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/event2/myComment/${idx}`, {}, { withCredentials: false });
            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async applyList(idx: number, param: types.ReqCommonPaging): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/event2/list/apply/${idx}`, param, { withCredentials: false });
            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async apply(idx: number, param: types.ReqBoardApplyForEvent): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/event2/apply/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(idx: number): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(
                "/board/event2/export/excel/" + idx,
                {},
                {
                    withCredentials: false,
                    responseType: "blob",
                },
            );

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
